import ApiService from "../api";

export default class FleetcomService extends ApiService {

    constructor() {
        super("/api/fleetcom");
    }


    listarVeiculos() {
        return this.get('/veiculos')
    }

    buscarVeiculoPorPlaca(placa) {
        return this.get(`/veiculos/${encodeURIComponent(placa)}`)
    }

    relatorioFrota() {
        return this.get('/relatorio-frota')
    }

    exportarExcel(dataInicial, dataFinal, placa) {
        return this.getFile(`/notas/exportar-excel?dataInicial=${dataInicial}&dataFinal=${dataFinal}&placa=1${placa}`)
    }

    dashboardNotasManutencao(dataInicial, dataFinal, placa) {
        return this.get(`/notas/dashboard?dataInicial=${dataInicial}&dataFinal=${dataFinal}&placa=1${placa}`)
    }


}
